import { render, staticRenderFns } from "./reportPaxTotalsTour.vue?vue&type=template&id=22f9229a&"
import script from "./reportPaxTotalsTour.vue?vue&type=script&lang=js&"
export * from "./reportPaxTotalsTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports